import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cart",
  "use": "cart-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"cart\"><path d=\"M237 390c-19 0-35 16-35 36 0 19 16 35 35 35s35-16 35-35c3-20-13-36-35-36zm176 0c-19 0-35 16-35 36 0 19 16 35 35 35s35-16 35-35c0-20-16-36-35-36zm41-67H202L112 61c0-7-10-13-16-13H19C10 48 0 58 0 67c0 10 10 19 19 19h64l87 263c3 6 9 13 19 13h269c9 0 19-10 19-20-3-9-10-19-23-19zm42-205L179 93h-3c-10 0-13 6-10 16l58 163c3 10 13 19 26 19h230c10 0 19-9 19-19l13-131c0-10-6-19-16-23zm-32 135H256l-42-119 260 23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cart.svg
// module id = 181
// module chunks = 0